var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnRightAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75468 9.99999C4.60565 10.0008 4.45974 9.9592 4.33554 9.88043C4.21135 9.80167 4.11451 9.68933 4.05736 9.55774C4.00021 9.42615 3.98534 9.28127 4.01466 9.14157C4.04397 9.00187 4.11614 8.87368 4.22196 8.77335L8.19864 4.97864L4.22196 1.18393C4.09903 1.0467 4.0348 0.870185 4.0421 0.689649C4.04939 0.509113 4.12767 0.337856 4.2613 0.210103C4.39493 0.0823493 4.57406 0.00750831 4.76289 0.000534976C4.95173 -0.00643836 5.13637 0.0549699 5.2799 0.172488L9.78181 4.4765C9.92156 4.6109 10 4.79271 10 4.98222C10 5.17173 9.92156 5.35354 9.78181 5.48795L5.2799 9.79196C5.14015 9.92448 4.95152 9.9992 4.75468 9.99999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.753739 9.99999C0.604894 10.0008 0.459162 9.95938 0.335125 9.88097C0.211088 9.80257 0.114364 9.69074 0.0572863 9.55975C0.000208414 9.42875 -0.0146379 9.28453 0.0146401 9.14547C0.0439182 9.0064 0.115994 8.8788 0.221679 8.77892L4.1934 5.00145L0.221679 1.22399C0.0805675 1.08953 0.00129195 0.907158 0.00129195 0.716998C0.00129196 0.526838 0.0805675 0.344467 0.221679 0.210004C0.36279 0.0755407 0.554178 1.4168e-09 0.753739 0C0.953301 -1.4168e-09 1.14469 0.0755407 1.2858 0.210004L5.78209 4.49446C5.92166 4.62825 6 4.80924 6 4.99788C6 5.18653 5.92166 5.36752 5.78209 5.50131L1.2858 9.78577C1.2164 9.85324 1.13363 9.90691 1.0423 9.94369C0.950969 9.98046 0.852888 9.9996 0.753739 9.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRightAero);
export default __webpack_public_path__ + "static/media/btn-right-aero.e8628cbf4205a2f38dd9f0c69a4ed422.svg";
export { ForwardRef as ReactComponent };